import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import {
  Collapse,
  Navbar,
  NavbarToggler,
  NavbarBrand,
  Nav,
  NavItem,
  NavLink,
  UncontrolledDropdown,
  DropdownToggle,
  DropdownMenu,
  DropdownItem,
  NavbarText,
} from 'reactstrap';

import OkafMenu from './OkafMenu';
import SponsorOl from './SponsorOl';
import Sponsorlar from './Sponsorlar';
import KatilimciOl from './KatilimciOl';
import SocialMedia from './SocialMedia';
import KatilimciFirmaMenu from './KatilimciFirmaMenu';


function NavigationBar(args) {
  const [isOpen, setIsOpen] = useState(false);
  const toggle = () => setIsOpen(!isOpen);

  return (
    <>
      <div class="miniNav">
        <div class="container">
          <div class="title">
            <i class="bi bi-house-fill"></i>
            <a href="https://okaf.samsun.edu.tr/" target="_blank" previewlistener="true">
              OKAF 2025
            </a>
          </div>
          <div class="phone">
            <a href="tel:+905393493955"><i class="bi bi-telephone-fill"></i>0 (539) 349 39 55</a>
          </div>
          <div class="mail">
            <a href="mailto:okaf@samsun.edu.tr"><i class="bi bi-envelope-fill"></i>okaf@samsun.edu.tr</a>
          </div>
          <SocialMedia />
        </div>
      </div>
      <div className="container-fluid py-3 siteNavbar">
        <div className="container">
          <Navbar {...args} className='navbar navbar-expand-lg '>
            <div className='navbar-brand'>
              <Link to="/">
                <img
                  width="300px"
                  src="/assets/img/logo.png" />
              </Link>
            </div>

            <NavbarToggler onClick={toggle} />

            <Collapse isOpen={isOpen} navbar>
              <Nav className="ms-auto me-3" navbar>
                <NavItem>
                  <NavLink tag={Link} to="/">
                    Ana Sayfa
                  </NavLink>
                </NavItem>

                <OkafMenu />

                <NavItem>
                  <NavLink tag={Link} to="paydaslar">
                    Paydaş Üniversiteler
                  </NavLink>
                </NavItem>



                {/* <NavItem>
                  <NavLink href="#">
                    OKAF24'ten
                  </NavLink>
                </NavItem> */}

                <Sponsorlar />
                {/* <SponsorOl /> */}

                {/* <KatilimciOl /> */}


                <NavItem>
                  <NavLink tag={Link} to="katilimcikurumfirmalar">
                    Katılımcı Kurum ve Firmalar
                  </NavLink>
                </NavItem>

                {/* <NavItem>
                  <NavLink tag={Link} to="kayitol">
                    Kayıt Ol
                  </NavLink>
                </NavItem> */}

                <NavItem>
                  <NavLink tag={Link} to="iletisim">
                    İletişim
                  </NavLink>
                </NavItem>
              </Nav>
              <div class="yuzYilLogo">
                <img alt="Türkiye Yüzyılı" src='/assets/img/yuzuncuyillogopng.png'></img>
              </div>
            </Collapse>
          </Navbar>
        </div>
      </div>
    </>
  );
}

export default NavigationBar;
